// @tenorlab/nuxt-dashboard-pro
// file: app/models/shared/Localization.utils.ts
import type { ISelectOption } from '../primitives'

/*
console.log(Intl.supportedValuesOf('calendar'));
console.log(Intl.supportedValuesOf('collation'));
console.log(Intl.supportedValuesOf('currency'));
console.log(Intl.supportedValuesOf('numberingSystem'));
console.log(Intl.supportedValuesOf('timeZone'));
console.log(Intl.supportedValuesOf('unit'));
*/
const _supportedCurrencyCodes: string[] = Intl.supportedValuesOf('currency')

const _currencyCodeOptions: ISelectOption[] = _supportedCurrencyCodes.map((x) => {
  return {
    value: x,
    text: x,
    selected: false,
  }
})

export const localizationUtils = {
  supportedCurrencyCodes: _supportedCurrencyCodes,
  currencyCodeOptions: _currencyCodeOptions,
}
